import { render, staticRenderFns } from "./BrandQueryResultPopup.vue?vue&type=template&id=77f5c6c9&scoped=true&"
import script from "./BrandQueryResultPopup.vue?vue&type=script&lang=ts&"
export * from "./BrandQueryResultPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5c6c9",
  null
  
)

export default component.exports